export const EyebrowLabel = ({ children, className = "" }) => (
  <div
    className={`inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-zinc-500 ${className}`}
  >
    <span className="h-px w-8 bg-[#EAB308]" />
    {children}
  </div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <EyebrowLabel>{eyebrow}</EyebrowLabel>}
    <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-zinc-950">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-5 text-base md:text-lg text-zinc-600 leading-relaxed">
        {subtitle}
      </p>
    )}
  </div>
);
